import React, { useState } from "react";

// reactstrap components
import { Button, Container, Row, Col, Form, Input, Alert } from "reactstrap";

export default function GetStarted (props) {

    const { newsletter = false } = props;

    const [ email, setEmail ] = useState('');

    const [ loading, setLoading ] = useState(false);
    const [ formSubmitted, setFormSubmitted ] = useState(false);

    const [ errorMessage, setErrorMessage ] = useState(null);

    const handleEmail = event => {
        setErrorMessage(null);
        setEmail(event.target.value);
    }

    const postForm = e => {

        e.preventDefault();
        setErrorMessage(null);

        if (email === null || email === "" || ! validEmail(email)) {
            setErrorMessage('Please provide a valid email address.');
            return false;
        }

        setLoading(true);

        _agile.create_contact({email: email}, {
            success: postContactDetails,
            error: postContactDetails
        });
        
    }

    const postContactDetails = () => {
        _agile.set_email(email);

        const task = {};
        const today = new Date();
        const date = new Date();

        date.setDate(today.getDate() + 7);

        task.type = "FOLLOW_UP";
        task.priority_type = "NORMAL";
        task.subject = "Follow up with contact from website newsletter form.";
        task.due = date.getTime();

        _agile.add_task(task);

        _agile.add_tag('Newsletter', {
            success: () => {
                setLoading(false);
                setFormSubmitted(true);
            },
            error: () => {
                setLoading(false);
                setErrorMessage("Looks like we have experienced an error. Please try again later.");
            }
        });
    }

    const validEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    return (
        <section className="section section-lg section-get-started">
            <Container>
                <Row className="row-grid justify-content-center">
                    <Col className="text-center" lg="8">
                        <h2 className="display-3">
                            Ready to launch your club
                            <span className="text-success">
                                into the digital age?
                            </span>
                        </h2>
                        <p className="lead">
                            Get started today with Club Apps. Create your user account and first club in just a few clicks. It's fast, easy and most importantly... free!
                        </p>
                        <div className="btn-wrapper">
                            <Button
                                className="mb-3 mb-sm-0"
                                color="success"
                                href="https://clubapps.org/register"
                                >
                                Get Started
                            </Button>
                        </div>
                    </Col>
                </Row>
                {newsletter &&
                    <>
                        <Row className="row-grid justify-content-center">
                            <Col className="text-center" lg="8">
                                <hr/>
                            </Col>
                        </Row>
                        <Row className="row-grid justify-content-center">
                            <Col className="text-center" lg="8">
                                <Form id="agile-form">
                                    <h4 className="display-5">
                                        Prefer to watch from the sideline?<br/>
                                        <span className="text-primary">
                                            Join our newsletter.
                                        </span>
                                    </h4>
                                    <div className="lead">
                                        {formSubmitted ? (
                                            <Alert color="success" className="mb-0">
                                                Thanks for joining our newsletter! You should now receive the occasional update from us regarding new features, fun anecdotes and more.
                                            </Alert>
                                        ) : (
                                            <div>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="newsletter-input-email"
                                                    placeholder="Email Address"
                                                    value={email}
                                                    onChange={handleEmail}
                                                    className={errorMessage ? 'is-invalid' : ''}
                                                    disabled={loading}
                                                />
                                                {(errorMessage) &&
                                                    <Alert color="danger" className="mt-4">
                                                        <strong>Warning!</strong> {errorMessage} 
                                                    </Alert>
                                                }
                                            </div>
                                        )}
                                    </div>
                                    {! formSubmitted &&
                                        <div className="btn-wrapper">
                                            <Button
                                                className="mb-3 mb-sm-0"
                                                color="primary"
                                                type="button"
                                                onClick={postForm}
                                                disabled={loading}
                                                >
                                                Join the Newsletter
                                            </Button>
                                        </div>
                                    }       
                                </Form>
                            </Col>
                        </Row>
                    </>
                }
            </Container>
        </section>
    );
}
